import React from 'react'
import clsx from 'clsx'
import {Typography} from './Typography'
import {Button} from './Button'

const ChamadaAzul = ({className, text, link, linkText}) => {
  return (
    <div
      className={clsx(
        className,
        'py-6 text-white bg-gradient-to-r from-blue-500 to-blue-900',
      )}
    >
      <div className="flex w-full max-w-5xl mx-auto">
        <Typography
          variant="heading"
          size="lg"
          className="flex-auto uppercase place-self-center"
        >
          {text}
        </Typography>
        <Button as="a" className="uppercase" href={link}>
          {linkText}
        </Button>
      </div>
    </div>
  )
}

export {ChamadaAzul}
